module.exports = __webpack_public_path__ + "static/media/one-finger-click@2x.016acd48.jpg";